import supabase from '../supabase/supabase';

const ADMIN_TABLE = 'admin_access_1774300900';

export const signInAdmin = async (email, password) => {
  const normalizedEmail = email.trim().toLowerCase();

  const { data, error } = await supabase.auth.signInWithPassword({
    email: normalizedEmail,
    password
  });

  if (error) throw error;

  const { data: authorization, error: authorizationError } = await supabase
    .from(ADMIN_TABLE)
    .select('id, email, active')
    .eq('email', normalizedEmail)
    .eq('active', true)
    .maybeSingle();

  if (authorizationError || !authorization) {
    await supabase.auth.signOut();
    throw new Error('This account does not have newsroom access.');
  }

  return data.session;
};

export const getAdminSession = async () => {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data.session?.user?.email) return null;

  const { data: authorization, error: authorizationError } = await supabase
    .from(ADMIN_TABLE)
    .select('id')
    .eq('email', data.session.user.email.toLowerCase())
    .eq('active', true)
    .maybeSingle();

  if (authorizationError || !authorization) return null;
  return data.session;
};

export const subscribeToAdminSession = (callback) => {
  const { data } = supabase.auth.onAuthStateChange(() => callback());
  return () => data.subscription.unsubscribe();
};

export const signOutAdmin = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};